import type { IntlShape } from 'react-intl'
import Image from 'components/Common/Image'

export function getStepsHowItWorks(intl: IntlShape) {
  return [
    {
      image: <Image id="waave-icon1" format="svg" height="60rem" />,
      title: intl.formatMessage({
        id: 'Bn5lGgk8TLV2Eb4lSPlm',
        defaultMessage: 'Pay By Bank:',
        description: 'Step 1 title for How it works section on Waave/LuxPay landing page',
      }),
      description: intl.formatMessage({
        id: 'MqbCi8EkGiMQPvVnxhNO',
        defaultMessage: 'Select Waave and Pay instantly from your bank',
        description: 'Step 1 description for How it works section on Waave/LuxPay landing page',
      }),
    },
    {
      image: <Image id="waave-icon2" format="svg" height="60rem" />,
      title: intl.formatMessage({
        id: 'Ta0sdrmF_id3_1egQDjt',
        defaultMessage: 'Fast Process:',
        description: 'Step 2 title for How it works section on Waave/LuxPay landing page',
      }),
      description: intl.formatMessage({
        id: 'VMOHcn5t_3ntzl-a1CxC',
        defaultMessage: 'Checkout without any need to remember your credit card or CCV numbers',
        description: 'Step 2 description for How it works section on Waave/LuxPay landing page',
      }),
    },
    {
      image: <Image id="waave-icon3" format="svg" height="60rem" />,
      title: intl.formatMessage({
        id: 'QIt8i-3mYoDygQkNnYOh',
        defaultMessage: 'Safe & Secure:',
        description: 'Step 3 title for How it works section on Waave/LuxPay landing page',
      }),
      description: intl.formatMessage({
        id: 'mHNkMDPRt0FcKeGsCRro',
        defaultMessage: 'Approve how you pay and who you trust, with safeguards for every transaction',
        description: 'Step 3 description for How it works section on Waave/LuxPay landing page',
      }),
    },
  ]
}

export function getStepsBuyNow(intl: IntlShape) {
  return [
    {
      title: '1',
      description: intl.formatMessage({
        id: 'QIvSVLb-dIfNWkMQWwvA',
        defaultMessage: 'Browse your favourite escapes',
        description: 'Step 1 description for Buy now section on Waave/LuxPay landing page',
      }),
    },
    {
      title: '2',
      description: intl.formatMessage({
        id: 'UUdZyZ8htuZt79dnoH85',
        defaultMessage: 'Select Waave Pay by Bank at checkout',
        description: 'Step 2 description for Buy now section on Waave/LuxPay landing page',
      }),
    },
    {
      title: '3',
      description: intl.formatMessage({
        id: 'jXt6NORn6OK9v9XYR4PG',
        defaultMessage: 'Connect your bank account & finalise your purchase',
        description: 'Step 3 description for Buy now section on Waave/LuxPay landing page',
      }),
    },
  ]
}

export function getTermsAndConditionsUrlLink(currency: string) {
  switch (currency) {
    case 'AUD':
      return 'https://luxuryescapes.com/au/promotions'
    default:
      return 'https://luxuryescapes.com/au/promotions'
  }
}

export function getTermsOfUseLink(currency: string) {
  switch (currency) {
    case 'AUD':
      return 'https://www.waave.com/legal/user-agreement/'
    default:
      return 'https://www.waave.com/legal/user-agreement/'
  }
}
